<template>
    <Dialog
      :visible.sync="showDeclaracoes"
      :modal="true"
      :closable="false"
    >
    <h1 class="titulo-header">
      Consulta de Declarações
      <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text" @click="showDeclaracoes = false"/>
    </h1><br/>
      <div class="scrolable-dialog">
        <div id="topo" class="row">
          <DataTable :value="declaracoesList" :paginator="true" :rows="10" class="p-datatable-responsive"
            :autoLayout="true">
            <Column field="tipoDeclaracao" header="Tipo Declaração"></Column>
            <Column field="numero" header="Número"></Column>
            <Column field="competenciaFormatada" header="Competência"></Column>
            <Column field="status" header="Status"></Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="ocultarDialogDeclaracoes()"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
</template>

<script>
import NotaFiscalService from "../../services/nfse/notafiscal.service";

export default {
  name: "ConsultaDeclaracoesNotaFiscal",

  data() {
    return {
      showDeclaracoes: false,
      consultaDeclaracao: null,
      messageList: null,
      declaracoesList: []
    };
  },

  created() {
    this.$root.$on("notaFiscal:consultaDeclaracoes", (tipo, id) => {
      this.pesquisar(tipo, id);
    });

    this.$root.$on("daps:consultaDeclaracoes", (tipo, id) => {
      this.pesquisar(tipo, id);
    });
    
  },

  methods: {
    pesquisar(tipo, id){
      this.declaracoesList = [];
      NotaFiscalService.listDeclaracoes(
        tipo === "D" ? "D" : "N",
        id
      ).then(
        response =>{
          
          if(response.length === 0){
            if(tipo === "D"){
              this.messageList = "O Daps não foi declarado!";
            }else if(tipo === "N"){
              this.messageList = "A Nota Fiscal não foi declarada!";
            }
            this.$toast.add({
              severity: "error",
              summary: this.messageList,
              life: 5000
            });
          }else{
            this.declaracoesList = response;
            this.showDeclaracoes = true;
          }
        },
        error => {
          let errorMessage = "Houve um problema ao listar as Declarações!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
        }
      );
    },
    ocultarDialogDeclaracoes() {
      this.showDeclaracoes = false;
    },

  },

  computed: {
    loading() {
      return this.$parent.loading;
    },
  },
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}
textarea {
  width: 100%;
  border-radius: 12px;
}
</style>